import { render, staticRenderFns } from "./phonebrand.vue?vue&type=template&id=157b93bc&scoped=true&"
import script from "./phonebrand.vue?vue&type=script&lang=js&"
export * from "./phonebrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b93bc",
  null
  
)

export default component.exports